// ui/mui/core/src/Breadcrumbs.tsx
import { Breadcrumbs as MUIBreadcrumbs, BreadcrumbsProps } from '@mui/material';
export const Breadcrumbs = (props: BreadcrumbsProps) => (
  <MUIBreadcrumbs data-testid="breadcrumbs" {...props} />
);
